import { AddPrimitivesCommand, BasicControl, BlockT, DYMODE_MODE, ExtrudeSurfaceT, Line, LineT, Listeners, MOUSE, Plane, Point, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode, vector3AngleTo } from 'pytha';
import { Vector3 } from "three";
import { ARCHI_CTRL_TYPE } from '../enums/archibase-control-type';
import { getSpecialPrimitiveLayerUuid } from '@/commons/utils/layer-utils';
import { LayerType } from '@/commons/enums/layer-type';

const STEP = {
    1: { 'tip': '指定站台的基点', 'mode': DYMODE_MODE.POINT },
    2: { 'tip': '指定站台的横向方向', 'mode': DYMODE_MODE.POINT },
    3: { 'tip': '指定站台的竖向方向', 'mode': DYMODE_MODE.POINT },
}
export class AssignStationControl extends BasicControl {


    id = ARCHI_CTRL_TYPE.ASSIGN_STATION;

    point_down: Point = new Point();
    point_move: Point = new Point();
    dymodePoint: Vector3 = new Vector3();
    capturePoint: Vector3;
    orthogonalPoint: Vector3;
    polarPoint: Vector3;

    step: number = 1;

    helpBlock: BlockT;
    originLines: LineT[]
    helpDir: Vector3 = new Vector3(1, 0, 0)

    point_1: Point;
    point_2: Point;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    isInit: boolean = false
    stationFirst: boolean = true
    length: number = 0
    stationDir: Vector3 = new Vector3()

    projectUuid: string = ""
    modelUuid: string = ""

    constructor(editor: ViewEditor, listeners: Listeners) {
        super()
        this.needInit = true;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.listeners.signals.needCapture.dispatch();

        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        listeners.signals.onPointCapture.add(this.onPointCapture);
        listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        listeners.signals.setInitControlData.add(this.initControl)
        listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.editor.clampControl.enabled = false
        // 钝化选择
        this.editor.selectControl.setEnabled(false);
        this.listeners.signals.emptySelectedEntities.dispatch()
        // 激活动态输入
        this.extraContext.dymodeContext.enabled = true;
        // 派发动态输入信息
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
        console.log("AssignStationControl add");
    }

    dispose(): void {
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.setInitControlData.remove(this.initControl)
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.orthogonalControl.enabled = false;
        this.editor.polarControl.enabled = false;

        let objBlock = this?.helpBlock?.viewObj;
        if (objBlock && !!objBlock.parent) {
            objBlock.parent.remove(objBlock);
        }
        console.log("AssignStationControl removed");
    }

    initControl = (data: any) => {
        // this.originLines = data.originLines
        this.originLines = []
        for (let i = 0; i < data.originLines.length; i++) {
            this.originLines.push(data.originLines[i].clone())
        }
        this.length = data.length
        this.stationFirst = data.stationFirst
        this.isInit = true
        this.projectUuid = data.projectUuid
        this.modelUuid = data.modelUuid
    }

    onPointPolarTracking = (point) => {
        this.polarPoint = point;
    }

    onPointOrthogonal = (point) => {
        this.orthogonalPoint = point;
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT || !this.isInit) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        } else if (this.orthogonalPoint) {
            this.point_down.copy(this.orthogonalPoint);
        } else if (this.polarPoint) {
            this.point_down.copy(this.polarPoint);
        }

        if (this.step == 1) {
            this.step_1()
        } else if (this.step == 2) {
            this.step_2()
        } else if (this.step == 3) {
            this.step_3()
        }
    }

    mirrorLine: LineT;
    private _helpPlane: Plane
    private _foot: Point = new Point()
    onPointerMove = () => {
        const x = this.extraContext.mousePosContext.x;
        const y = this.extraContext.mousePosContext.y;
        const z = this.extraContext.mousePosContext.z;
        this.point_move.set(x, y, z);
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        } else if (this.orthogonalPoint) {
            this.point_move.copy(this.orthogonalPoint);
        } else if (this.polarPoint) {
            this.point_move.copy(this.polarPoint);
        }

        switch (this.step) {
            case 1:
                // 无任何操作
                break;
            case 2:
                this._helpPlane.projectPoint(this.point_move, this._foot)
                this.point_move.copy(this._foot)
                // 旋转 helpBlock
                // 计算旋转角度
                let newDir = new Vector3().copy(this.point_move).sub(this.point_1).normalize()
                let angle = vector3AngleTo(this.helpDir, newDir, new Vector3(0, 0, 1)) || 0
                this.helpBlock.rotate(this.point_1, new Vector3(0, 0, 1), angle)
                this.helpBlock.updateViewGeometry();
                if (angle != 0) {
                    this.helpDir.copy(newDir)
                }
                break;
            case 3:
                (this.helpDir.copy(this.point_move)).sub(this.point_1).normalize()
                // 判断是否需要mirror
                if (this.helpDir.dot(this.stationDir) < 0) {
                    this.helpBlock.mirror(this.mirrorLine)
                    this.helpBlock.updateViewGeometry()
                    this.stationDir.negate()
                }
                break;
            default:
                break;
        }
    }

    _dymodeActive = false;
    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.dymodePoint.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        }
    }

    onKeyMouseConfirm = () => {
        this.point_down.copy(this.dymodePoint);
        if (this.step == 1) {
            this.step_1()
        } else if (this.step == 2) {
            this.step_2()
        } else if (this.step == 3) {
            this.step_3()
        }
    }

    // 确定第一个点位置，初始化helpBlock
    step_1 = () => {
        this.point_1 = this.point_down.clone()
        let moveDir = this.point_1.clone().normalize()
        for (let i = 0; i < this.originLines.length; i++) {
            this.originLines[i].move(moveDir, this.point_1.length())
        }
        this.helpBlock = new BlockT(this.point_1.clone(), this.originLines, "", new Vector3(0, 0, 1), new Vector3(1, 0, 0))
        let blockView = this.helpBlock.render()
        this.extraContext.sceneContext.scene.add(blockView)

        this.listeners.signals.needRender.dispatch();
        this.listeners.signals.needCapture.dispatch(this.point_down);
        this.listeners.signals.orthogonal.dispatch(this.point_down);
        this.listeners.signals.polarTracking.dispatch(this.point_down);
        this.step++
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);

        this._helpPlane = new Plane()
        this._helpPlane.setFromNormalAndCoplanarPoint(new Vector3(0, 0, 1), this.point_1.clone())
    }

    step_2 = () => {
        // 使用pointDown进行一次旋转，避免错误
        this._helpPlane.projectPoint(this.point_down, this._foot)
        this.point_down.copy(this._foot)
        let newDir = new Vector3().copy(this.point_down).sub(this.point_1).normalize()
        let angle = vector3AngleTo(this.helpDir, newDir, new Vector3(0, 0, 1)) || 0
        this.helpBlock.rotate(this.point_1, new Vector3(0, 0, 1), angle)

        // 确认横向方向
        this.point_2 = this.point_down.clone()
        let dir = (this.point_2.clone().sub(this.point_1).cross(new Vector3(0, 0, 1))).normalize()
        this.stationDir.copy(dir)
        this.mirrorLine = new LineT(this.point_1, this.point_2)
        let lines = this.helpBlock.getEntities() as LineT[]
        let stationType = this.stationFirst ? 1 : 2
        // 绘制helpfaces
        let helpFaces: ExtrudeSurfaceT[] = []
        // stationType为1，类型为站台，获取三条线，为2，类型为股道，获取一条线
        for (let i = 0; i < lines.length;) {
            if (stationType == 1) {
                // 获取三个拉伸面
                let extFace_1 = new ExtrudeSurfaceT([lines[i++]._geo.clone()], dir, this.length)
                let extFace_2 = new ExtrudeSurfaceT([lines[i++]._geo.clone()], dir, this.length)
                let extFace_3 = new ExtrudeSurfaceT([lines[i++]._geo.clone()], dir, this.length)
                extFace_1.changeColor("#2469EF")
                extFace_2.changeColor("#2469EF")
                extFace_3.changeColor("#2469EF")
                stationType = 2
                helpFaces.push(extFace_1)
                helpFaces.push(extFace_2)
                helpFaces.push(extFace_3)

            } else {
                let extFace_1 = new ExtrudeSurfaceT([lines[i++]._geo.clone()], dir, this.length)
                extFace_1.changeColor("#7FC112")
                stationType = 1
                helpFaces.push(extFace_1)
            }
        }
        // 清除helpBlock并重新生成
        let objBlock = this?.helpBlock?.viewObj;
        if (objBlock && !!objBlock.parent) {
            objBlock.parent.remove(objBlock);
            this.helpBlock.viewObj = null
        }
        this.helpBlock.setEntities(helpFaces)
        let blockView = this.helpBlock.render()
        this.extraContext.sceneContext.scene.add(blockView)

        this.step++
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
        this.listeners.signals.needRender.dispatch();
        this.listeners.signals.needCapture.dispatch(this.point_down);
        this.listeners.signals.orthogonal.dispatch(this.point_down);
        this.listeners.signals.polarTracking.dispatch(this.point_down);
    }

    step_3 = () => {
        // 使用point_down进行一次mirror判断
        (this.helpDir.copy(this.point_down)).sub(this.point_1).normalize()
        if (this.helpDir.dot(this.stationDir) < 0) {
            this.helpBlock.mirror(this.mirrorLine)
            this.stationDir.negate()
        }

        getSpecialPrimitiveLayerUuid(this.projectUuid, this.modelUuid, LayerType.STATION).then((layerUuid: string) => {
            // 确认faces
            let helpFaces = this.helpBlock.getEntities() as ExtrudeSurfaceT[]
            let command = new AddPrimitivesCommand(helpFaces.map(item => {
                item.isColorByLayer = false
                item.layerUuid = layerUuid
                return (
                    item.clone()
                )
            }))
            this.editor.history.execute(command);
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        })
    }
}